<template>
  <div class="setting-post-time-page">
    <ins-selector v-model="selectPublisherId"></ins-selector>
    <div class="right-container">
      <div class="header-container">Manage Caption or Comment</div>
      <div class="main-container" ref="caption">
        <manager-tab class="tab-container" :tab-list="tabList">
          <div class="operation-container">
            <div v-if="!edit" class="tab-btn" @click="editClick">Edit</div>
            <template v-else>
              <div class="tab-btn" @click="saveClick">Save</div>
              <div class="tab-btn" @click="cancelClick">Cancel</div>
            </template>
          </div>
        </manager-tab>
        <div class="select-caption-container" @click="showAddModal = true">
          <div class="add-icon"></div>
          <div class="select-text">Add New {{ typeText }}</div>
        </div>
        <div class="scroller-container">
          <div
            v-if="!item.del"
            class="comment-item"
            v-for="item in defaultList"
            :key="item.id"
          >
            <div class="text">{{ item.content }}</div>
            <div class="default-icon" v-if="item.is_default">default</div>
            <div class="icon-container" v-if="edit">
              <div class="del-icon" @click="item.del = true"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="add-modal" v-if="showAddModal">
      <caption-add
        :type="type"
        @success="addSuccess"
        @close="showAddModal = false"
        :publisher-id="selectPublisherId"
      ></caption-add>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../store/mutation-types";
import insSelector from "../../components/common/instagram_selector/Selector";
import ManagerTab from "../../components/setting/ManagerTab";
import { getUserContent, delUserContent } from "../../service/publisher";
import { showErrorMsg } from "../../utils/errors";
import CaptionAdd from "../../components/setting/default_caption/Add";
export default {
  name: "SettingManagerCaptionPage",
  components: { insSelector, ManagerTab, CaptionAdd },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    type() {
      const select = this.tabList.find((t) => t.select);
      return select.id;
    },
    typeText() {
      const selectPublisher = this.user.linkedInstagramList.find(
        (l) => l.publisherId === this.selectPublisherId
      );
      if (selectPublisher) {
        if (selectPublisher.socialNetwork === 4) {
          if (this.type === "caption") {
            return "Tweets";
          } else {
            return "Reply";
          }
        } else {
          if (this.type === "comment") {
            return "Comment";
          } else {
            return "Caption";
          }
        }
      }
    },
    defaultList() {
      if (this.type === "caption") {
        return this.caption;
      } else {
        return this.comment;
      }
    },
  },
  data() {
    return {
      selectPublisherId: "",
      showAddModal: false,
      caption: [],
      comment: [],
      edit: false, // 是否处于编辑状态
      tabList: [
        { id: "caption", text: "Saved Caption", select: true, hide: false },
        {
          id: "comment",
          text: "Saved Comment",
          select: false,
          hide: false,
        },
      ],
    };
  },
  methods: {
    async addSuccess(item) {
      const loading = this.$loading({ target: this.$refs.caption });
      try {
        await this.reload();
        this.showAddModal = false;
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
    /**
     * 编辑按钮点击事件
     */
    editClick() {
      this.edit = true;
    },
    /**
     * 编辑按钮点击事件
     */
    async saveClick() {
      const loading = this.$loading({ target: this.$refs.caption });
      try {
        // 记录所有未删除选项
        const ids = [];
        this.caption.forEach((i) => {
          if (i.del) {
            ids.push(i.id);
          }
        });
        this.comment.forEach((i) => {
          if (i.del) {
            ids.push(i.id);
          }
        });
        await delUserContent({ publisherId: this.selectPublisherId, ids });
        await this.reload();
        this.edit = false;
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
    /**
     * 取消按钮点击事件
     */
    cancelClick() {
      // 取消时候取消所有del
      this.caption.forEach((i) => {
        i.del = false;
      });
      this.comment.forEach((i) => {
        i.del = false;
      });
      this.edit = false;
    },
    async reload() {
      // 获取当前选中人的saved信息
      const captionList = await getUserContent({
        type: "caption",
        publisherId: this.selectPublisherId,
      });
      const commentList = await getUserContent({
        type: "comment",
        publisherId: this.selectPublisherId,
      });
      captionList.forEach((i) => {
        i.del = false;
      });
      commentList.forEach((i) => {
        i.del = false;
      });
      this.caption = captionList.filter((i) => i.is_saved);
      this.comment = commentList.filter((i) => i.is_saved);
    },
  },
  watch: {
    /**
     * 切换用户重新获取saved 信息
     * @param val
     * @param old
     * @return {Promise<void>}
     */
    async selectPublisherId(val, old) {
      if (val) {
        const loading = this.$loading({ target: this.$refs.caption });
        try {
          // 获取当前选中的publisher信息
          const selectPublisher = this.user.linkedInstagramList.find(
            (l) => l.publisherId === this.selectPublisherId
          );
          // 如果选中的是facebook group则没有comment
          if (selectPublisher.socialNetwork === 3) {
            // 隐藏comment 同时选中caption
            this.tabList[1].hide = true;
            this.tabList[0].select = true;
            this.tabList[1].select = false;
          } else {
            this.tabList[1].hide = false;
          }
          if (selectPublisher.socialNetwork === 4) {
            this.tabList[0].text = "Tweet";
            this.tabList[1].text = "First Reply";
          } else {
            this.tabList[0].text = "Caption";
            this.tabList[1].text = "First Comment";
          }
          await this.reload();
        } catch (e) {
          showErrorMsg(e);
        } finally {
          loading.close();
        }
      }
    },
  },
};
</script>
<style scoped lang="less">
@import "../../assets/style/theme.less";

.add-modal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
}

.setting-post-time-page {
  display: flex;
  flex: 1;

  .right-container {
    flex: 1;
    height: 100vh;

    .header-container {
      height: 80px;
      border-bottom: 1px solid @border-color;
      display: flex;
      align-items: center;
      font-size: 18px;
      font-weight: 500;
      padding-left: 40px;
    }

    .main-container {
      display: flex;
      flex-direction: column;
      height: calc(~"100vh - 80px");
      min-width: 700px;
      .tab-container {
        margin: 46px 40px 0 40px;

        .operation-container {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          height: 100%;

          .tab-btn {
            color: @theme-color;
            margin-left: 20px;
            cursor: pointer;

            &:hover {
              opacity: 0.7;
            }
          }
        }
      }

      .select-caption-container {
        height: 64px;
        display: flex;
        cursor: pointer;
        align-items: center;
        margin: 0 40px;
        border-bottom: 1px solid @border-color;
        &:hover {
          opacity: 0.7;
        }

        .add-icon {
          width: 16px;
          height: 16px;
          background-size: contain;
          background-image: url("../../../public/images/common/add_ins.png");
        }

        .select-text {
          text-transform: capitalize;
          padding-left: 8px;
          font-size: 16px;
          color: @theme-color;
        }
      }

      .scroller-container {
        flex: 1;
        overflow: auto;
        padding: 0 40px;

        .comment-item {
          min-height: 64px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid @border-color;
          padding: 10px 0;

          .default-icon {
            background: @theme-color;
            color: white;
            font-size: 8px;
            padding: 2px 4px;
            margin-left: 10px;
          }

          .text {
            font-size: 14px;
            white-space: pre-wrap;
            word-break: break-all;
            flex: 1;
          }

          .icon-container {
            width: 35px;
            display: flex;
            align-items: center;
            justify-content: center;

            .del-icon {
              width: 15px;
              height: 15px;
              background-size: contain;
              cursor: pointer;
              background-image: url("../../../public/images/setting/default caption_delete@3x.png");
            }
          }
        }
      }
    }
  }
}
</style>
